const escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
};

const searchPattern = new RegExp(`[${Object.keys(escapeMap).join('')}]`, 'g');

/**
 * @param {string} text
 * @returns {string}
 */
export const escapeHTML = function (text) {
  return text.replace(searchPattern, substring => escapeMap[substring]);
}

export default escapeHTML;
